import { render } from "./TournamentPlayer.vue?vue&type=template&id=ccad7df2"
import script from "./TournamentPlayer.vue?vue&type=script&lang=js"
export * from "./TournamentPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__